import * as React from 'react';
import onToastClicked from '../utils/onToastClicked';
import ToastItem from '../store/schema/ToastItem';
import toastViewState from '../store/Store';
import { observer } from 'mobx-react';

const styles = require('./Toast.scss');
const classNames = require('classnames/bind').bind(styles);

export interface ToastProps extends React.HTMLProps<HTMLAnchorElement> {
    item: ToastItem;
    onRetry: (remainingRetries: number) => void;
}

/**
 * Component which shows the toast
 * @param props
 */
export default observer(function Toast(props: ToastProps) {
    const { item, onRetry } = props;

    // Show the toast only when a valid object is sent and only when view state has its value true
    if (toastViewState.isToastShown && item) {
        const { className, onButtonClick, icon, label, buttonLabel, numberOfRetriesAllowed } = item;
        // The toast component or its children are not tabbable and when the popup arrives, aria-live should read the text of the component
        return (
            <div
                aria-hidden="true"
                className={classNames(
                    styles.toast,
                    className ||
                        styles.plain /* When there is no style passed, pass plain to the icon to get the default settings */
                )}>
                {icon && <i className={classNames('ms-Icon', icon)} />}
                <div className={styles.toastLabel}>{label}</div>
                {onButtonClick && buttonLabel && (
                    <a
                        role="button"
                        className={styles.actionButton}
                        onClick={evt =>
                            onToastClicked(evt, numberOfRetriesAllowed, onButtonClick, onRetry)
                        }>
                        {buttonLabel}
                    </a>
                )}
            </div>
        );
    }

    return null;
});
